import { v4 as uuidv4 } from "uuid";
import {
  getAllPrimaryBeneficiaryFromParties,
  getAllContingentBeneficiaryFromParties,
  isFlagEnabled,
} from "js/utilities";
import {
  getNameWithPercentageSplit,
  stringFormattingToCurrency,
} from "js/formatting";

import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";
import { useTranslation, Trans } from "react-i18next";

export default function DeathBenefitCard({ data, deathBenefit }) {
  const uuid = uuidv4();

  const primaryBeneficiaries = getAllPrimaryBeneficiaryFromParties(
    data.parties
  );
  const contingentBeneficiaries = getAllContingentBeneficiaryFromParties(
    data.parties
  );

  const showDisclaimer = !(
    primaryBeneficiaries.length > 0 && contingentBeneficiaries.length === 0
  );
  const { t } = useTranslation();

  return (
    <CardWithFields
      additionalContent={
        <>
          <div>
            <h2 className="mb-0">
              <span className="text-base font-body font-bold pl-4 xl:px-6 xl:pt-2">
                {t("AgentDeathBenefitCard-beneficiary")}
              </span>
            </h2>

            <div
              id={`${uuid}-panel`}
              className="px-4 pb-4 overflow-hidden h-20 mt-4 md:h-auto md:mt-0 xl:px-6 xl:pb-6 overflow-y-auto"
            >
              {/* <!-- Beneficiary(s) Details --> */}
              <div className="grid grid-cols-2 gap-4 xl:gap-6">
                {primaryBeneficiaries?.length > 0 && (
                  <div>
                    <div className="text-xs text-theme-text-tertiary">
                      {t("AgentDeathBenefitCard-primary-beneficiary")}
                    </div>
                    {primaryBeneficiaries?.map((primaryBeneficiary, idx) => {
                      return (
                        <Trans
                          i18nKey={getNameWithPercentageSplit(
                            primaryBeneficiary?.person,
                            primaryBeneficiary?.splitPercent,
                            primaryBeneficiary?.sharedEquallyFlag,
                            primaryBeneficiaries.length
                          )}
                          components={{
                            div1: (
                              <div className="text-sm text-theme-text-secondary font-semibold whitespace-nowrap" />
                            ),
                            div2: <span className="text-theme-text-tertiary" />,
                          }}
                        />
                      );
                    })}
                  </div>
                )}

                {contingentBeneficiaries?.length > 0 && (
                  <div>
                    <div className="text-xs text-theme-text-tertiary">
                      {t("AgentDeathBenefitCard-contingent-beneficiary")}
                    </div>
                    {contingentBeneficiaries?.map((contingent, idx) => {
                      return (
                        <Trans
                          i18nKey={getNameWithPercentageSplit(
                            contingent?.person,
                            contingent?.splitPercent,
                            contingent?.sharedEquallyFlag,
                            contingentBeneficiaries.length
                          )}
                          components={{
                            div1: (
                              <div className="text-sm text-theme-text-secondary font-semibold whitespace-nowrap" />
                            ),
                            div2: <span className="text-theme-text-tertiary" />,
                          }}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>

          {showDisclaimer && (
            <CardDisclaimerBase disclaimer={t("AgentDeathBenefitCard-desc")} />
          )}
        </>
      }
      ariaLabel={t("AgentDeathBenefitCard-label")}
      cardTitle={t("AgentDeathBenefitCard-card-title")}
      cardFields={[
        {
          title: t("AgentDeathBenefitCard-card-title"),
          value: stringFormattingToCurrency(deathBenefit),
          hidden: data.streams?.length > 0,
        },
      ]}
    />
  );
}
